import React from 'react';
import { ChartDataFetchError } from '../../charts/ChartDataFetchError';
import ErrorDisplay, { ErrorDisplayProps } from './ErrorDisplay';

interface ChartErrorDisplayProps extends Omit<ErrorDisplayProps, 'fallback'> {
  retry?: () => void;
}

export const ChartErrorDisplay = (props: ChartErrorDisplayProps) => {
  const {
    error,
    className,
    variant = 'inline',
    whiteIcon = false,
    retry,
  } = props;
  return (
    <ErrorDisplay
      error={error}
      className={className}
      variant={variant}
      whiteIcon={whiteIcon}
      fallback={<ChartDataFetchError errorData={{ error }} retry={retry} />}
    />
  );
};
